import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../utilities/requestClient';
import { RSFundPageModel } from '../../../../api/api.types';
import {
  formatFundUrl,
  makeUniqueDataKey,
} from '../../../../utilities/urlBuilder';

export type RelevantCounterpartyPageModel = RSFundPageModel<Record<string, any>>;

export function useActiveCounterpartyAgg(
  fundId: string,
  positionDate: string | undefined,
  options?: Omit<
    UseQueryOptions<any, unknown, any, string[]>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
) {
  return useQuery({
    queryKey: [
      makeUniqueDataKey(fundId, 'counterpartyAgg', positionDate),
      fundId,
      positionDate || '',
    ],
    queryFn: async () => {
      const url = formatFundUrl('active_counterparty_agg', fundId, positionDate!);
      return (await AxiosInstance.get(url)).data;
    },
    enabled: !!fundId && !!positionDate,
    ...options,
  });
}

export function useRelevantCounterpartyData(
  fundId: string,
  counterpartyId: string | null,
  positionDate: string | undefined,
  options?: Omit<
    UseQueryOptions<RelevantCounterpartyPageModel, Error>,
    'queryKey' | 'queryFn'
  >,
) {

  return useQuery<RelevantCounterpartyPageModel, Error>({
    queryKey: [
      `${fundId}_${positionDate || ''}_${counterpartyId || ''}`,
      fundId,
      counterpartyId || '',
      positionDate || '',
    ],
    queryFn: async () => {
      const url = `get_counterparty_exposure/${fundId}/${counterpartyId!}/${positionDate!}`;
      return (
        await AxiosInstance.get<RelevantCounterpartyPageModel>(url)
      ).data;
    },
    enabled: !!fundId && !!counterpartyId && !!positionDate,
    ...options,
  });
}

